import { useMemo } from 'react';

import { useWebAttendeesTableQuery } from '@src/hooks/queries/useWebinarQuery';

import { IAttendeesFilters } from '@src/types';
import { IAttendee } from '@src/webinar/types';

const useWebinarAttendees = (roomId: string, filters: IAttendeesFilters) => {
  const { data: apiData, ...rest } = useWebAttendeesTableQuery(roomId, filters);
  const data = useMemo(
    () =>
      apiData?.pages?.reduce((acc: IAttendee[], page: { result: IAttendee[] }) => [...acc, ...(page.result || [])], []),
    [apiData]
  );
  return {
    data,
    ...rest,
  };
};

export default useWebinarAttendees;
